import { render, staticRenderFns } from "./add-funds.vue?vue&type=template&id=bb4f74e6"
import script from "./add-funds.vue?vue&type=script&lang=js"
export * from "./add-funds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports